import { ResultDto } from '@domain/rs/phs/test/ResultListRs';
import { PHSAnalysisType, phsAnalysisTextMap } from '@domain/constant/phsAnalysisType';
import DateFormat from '@utils/date/format';

export default class ResultVO {
  applySn: number;
  createdDateTime: string;
  analysisType: PHSAnalysisType;
  analysisText: string;

  constructor(rs: ResultDto) {
    this.applySn = rs.applySn;
    this.createdDateTime = DateFormat.format(new Date(rs.createdDateTime), 'yyyy년 MM월 dd일 HH:mm');
    this.analysisType = rs.analysisType;
    this.analysisText = phsAnalysisTextMap[rs.analysisType];
  }
}
